<script lang="ts" setup>
//
</script>

<template>
  <div class="crumbs-wrapper">
    {{ $t('4wtlPFFdgy8HlmD_V7beI') }}<NuxtLink :to="localePath('/')"> <span class="hover:text-[#148AF5]">{{ $t('tXRmdyXSXwjXI1ckkd-W4') }}</span></NuxtLink> -
    <NuxtLink :to="localePath('/announcement')"><span class="hover:text-[#148AF5]">{{ $t('dTKmOOljwW8ju5qOEXBtv') }}</span></NuxtLink>
  </div>
</template>

<style lang="scss" scoped>
.crumbs-wrapper {
  color: #616674;

  a {
    color: inherit;
  }
}
</style>
